import cn from 'classnames'
import React from 'react'

import { ComponentType } from '../../lib/types'
import NavigationIcon from '../NavigationIcon'
import styles from './NavigationGroup.module.scss'

import { PreferLinkType } from '~types/utils'

export interface BaseNavigationGroupLinkProps {
  children: React.ReactNode
  icon?: React.ReactNode
  selected?: boolean
  hovered?: boolean
  component?: ComponentType
}

type NavigationGroupLinkProps = BaseNavigationGroupLinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement>

function NavigationGroupLink<T extends unknown>({
  component: Component = 'a',
  children,
  icon,
  selected,
  hovered,
  className,
  ...props
}: PreferLinkType<BaseNavigationGroupLinkProps, NavigationGroupLinkProps, T>) {
  return (
    <Component
      className={cn(styles.itemLink, selected && styles.selected, hovered && styles.hovered, className)}
      {...props}
    >
      {icon && <NavigationIcon className={styles.icon}>{icon}</NavigationIcon>}
      <span className={styles.content}>{children}</span>
    </Component>
  )
}

export default NavigationGroupLink
